export default __webpack_public_path__ + "static/media/Minus.742641c0.svg";